import type { AllowedList } from '../types';

export function isPetitionInAllowedList(id: string, petitions: AllowedList) {
	return petitions && petitions.some(({ petitionId }) => petitionId === id);
}
